export const checkRegex = (regex, value, parsedRepeat) => {
    if (parsedRepeat && parsedRepeat > 1) {
        return new RegExp(regex + '{' + parsedRepeat + ',}').test(value);
    }
    return new RegExp(regex).test(value);
};
//# sourceMappingURL=checkRegex.js.map